module.exports = __webpack_public_path__ + "img/ic_head_voltar_branco.1078dfc6.svg";